import $ from 'jquery';

$(document).ready(function() {
    $('.js-modal-slider-result').slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 700,
            settings: {
                dots: false,
                slidesToShow: 2.2,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        }
        ]
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-result/game-slider-result.js